/*
 * @Author: Eugene
 * @Date: 2020-04-13 19:58:43
 * @Last Modified by: Eugene
 * @Last Modified time: 2021-05-26 18:27:55
 */
import { message } from 'antd';
import {
  getLiveClassList,
  getLiveClassInfo,
  updatePlaybackUrl,
  bindLiveChannelAndSupplementData,
} from '../../../services/live/liveContentLibrary';
import { getLiveChannelEnableList } from '../../../services/live';

export default {
  namespace: 'liveContentLibrary',

  state: {
    dataSource: [],
    pageData: {},
    pagination: {
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total) => `共 ${total} 条`,
    },
    channelList: [],
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const res = yield call(getLiveClassList, payload);
      if (res.code === '00000') {
        yield put({
          type: 'fetchSuccess',
          payload: {
            dataSource: res.data,
            pagination: {
              current: res.page.currentPage,
              pageSize: res.page.pageSize,
              total: res.page.count,
            },
          },
        });
      } else {
        message.error('获取直播内容库失败！', 3);
      }
    },
    *fetchDetail({ payload }, { call, put }) {
      if (payload.requestData) {
        const res = yield call(getLiveClassInfo, payload);
        if (res.code === '00000') {
          yield put({
            type: 'fetchDetailOk',
            payload: {
              pageData: res.data,
            },
          });
        } else {
          message.error(res.msg, 3);
        }
      } else {
        yield put({
          type: 'fetchDetailOk',
          payload: {
            pageData: {},
          },
        });
      }
    },
    *fetchUpdate({ payload }, { call, put }) {
      const { requestData, resolve, reject } = payload;
      const res = yield call(updatePlaybackUrl, { requestData });
      if (res.code === '00000') {
        resolve(res);
      } else {
        reject(false);
        message.error(`${res.msg}`, 3);
      }
    },
    *fetchChannelList(_, { call, put, select }) {
      const liveContentLibrary = yield select(
        (state) => state.liveContentLibrary,
      );
      if (liveContentLibrary.channelList.length) return;
      const res = yield call(getLiveChannelEnableList, {});
      if (res.code === '00000') {
        yield put({
          type: 'fetchChannelListOk',
          payload: {
            channelList: res.data,
          },
        });
      } else {
        message.error(res.msg, 3);
      }
    },
    *bindLiveChannelAndSupplementData({ payload }, { call }) {
      const { requestData, resolve } = payload;
      const res = yield call(bindLiveChannelAndSupplementData, { requestData });
      if (res.code === '00000') {
        resolve(res);
      } else {
        message.error(`${res.msg}`, 3);
      }
    },
  },

  reducers: {
    fetchSuccess(state, action) {
      const { dataSource, pagination } = action.payload;
      return {
        ...state,
        dataSource,
        pagination: {
          ...state.pagination,
          ...pagination,
        },
      };
    },
    fetchChannelListOk(state, action) {
      const { channelList } = action.payload;
      return {
        ...state,
        channelList,
      };
    },
    fetchDetailOk(state, action) {
      const { pageData } = action.payload;
      return {
        ...state,
        pageData,
      };
    },
    fetchUpdateOk(state, action) {
      const { pageData } = action.payload;
      return {
        ...state,
        pageData,
      };
    },
  },
};
